import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InventoryItemUtilService {
  private _defaultBookValue: any;

  set defaultBookValue(event: any) {
    this._defaultBookValue = event;
  }
  get defaultBookValue() {
    return this._defaultBookValue;
  }
}
